import { call, put, takeEvery, cancel, select, fork, delay } from 'redux-saga/effects';
import { START_ROCKY_EXPERIMENT } from './actionTypes';
import { verificationWorkFlow, getWorkflowTask, updateWorkflowTask } from '../saga';
import { VERIFY_SUCCESS, VERIFY_RUNNING, WAITING, ERROR } from '@/constants/verificationStatus';
import { getExperimentListPromise, runSweepingPromise, SweepContentData } from '../../../../../services/Rocky';
import { updateErrorCheckList } from '../../rocky/action';
import { updateExperimentInfo, updateExperimentStatus } from '../../rockySweep/action';
import { changeTabMenu } from '../../../../MonitorStore/action';
import { API_RES_MESSAGE } from '../../../../../constants/returnCode';
import { changeVerificationList, getVerificationLog, updateCurrentSimulationInfo, updateSimulationReducer } from '../action';
import { EXPERIMENTS } from '../../../../../constants/treeConstants';
import {
  checkVerificationStatus,
  getVerificationWorkFlow
} from '@/services/workflow/workflow';
import { getSweepErrorCheck } from '../../../errorCheck/sweepCheck';

let experimentTask = null
let workflowTask = getWorkflowTask();
function* startExperiment(action) {
  const { forSim, clear, run } = action;

  let waitingTask = null;
  let reducer = yield select();
  let simulationReducer = reducer.RockyReducer.simulationReducer;
  //cancel prev workflow task
  if (workflowTask) {
    yield cancel(workflowTask);
  }

  const { RockyReducer: { simulationReducer: { experimentQueue = [] }, project: { currentProjectId, spiceList, onDieSpiceList, ibisList, ibisAmiList, vectorList }, rocky: { infoErrorCheck }, sweep: { experimentInfo: { experiments, base, id: groupId } } } } = yield select();

  const sweepList = [base, ...experiments].filter(item => !!item);

  const ExpList = SweepContentData.getExpList(groupId)

  let forSimVerificationId = [];
  forSim.forEach(item => {
    const info = ExpList.find(it => it.id === item || it.verificationId === item)
    forSimVerificationId.push({ verificationId: info.verificationId, id: info.id })
  })

  let tasks = clear ? [...forSimVerificationId] : forSimVerificationId.filter(task => !experimentQueue.includes(task));

  let newTasks = [], errorList = [...infoErrorCheck], statusError = [];
  const libraryInfo = { ibisList, ibisAmiList, spiceList, vectorList, onDieSpiceList }

  for (let taskInfo of tasks) {
    // const error = yield call(checkExperimentInfo, task);
    const task = taskInfo.verificationId;
    const info = sweepList.find(it => it.verificationId === taskInfo.verificationId)
    const error = yield call(getSweepErrorCheck, { expContent: info, baseContent: base, libraryInfo });
    if (error && error.length) {
      statusError.push(task)
      // yield put(cleanMonitor(task))
      // const index = errorList.findIndex(item => item.verificationId === task);
      // if (index > -1) {
      //   errorList[index].errorCheck = error;
      // } else {
      errorList.push({
        verificationId: task,
        errorCheck: { error }
      })
      // }

    } else {
      newTasks.push(taskInfo);
      errorList = errorList.filter(item => item.verificationId !== task);
    }
  }

  yield put(updateErrorCheckList(errorList));

  let currentVerificationId = forSimVerificationId[0].verificationId;
  if (statusError.length) {
    yield put(updateExperimentStatus({ experimentIds: statusError, status: ERROR }));
    if (!newTasks.length) {
      let verification = sweepList.find(item => item.verificationId === statusError[0]);
      currentVerificationId = statusError[0]
      yield put(changeTabMenu({
        selectKeys: ['monitor'],
        menuType: 'simulation',
        currentVerificationId: statusError[0],
        projectId: currentProjectId,
        verificationName: verification ? verification.name : 'Base',
        currentChannelId: groupId,
        dataType: EXPERIMENTS,
      }));
    }
  }

  if (newTasks.length) {
    try {
      currentVerificationId = newTasks[0].verificationId
      let verification = sweepList.find(item => item.verificationId === currentVerificationId);
      yield put(changeTabMenu({
        selectKeys: ['monitor'],
        menuType: 'simulation',
        currentVerificationId: currentVerificationId,
        projectId: currentProjectId,
        verificationName: verification ? verification.name : 'Base',
        currentChannelId: groupId,
        dataType: EXPERIMENTS,
      }));

      const runList = newTasks.map(item => item.id)
      yield call(runSweepingPromise, runList);

      newTasks = [...experimentQueue, ...newTasks];
    } catch (error) {
      if (waitingTask) { yield cancel(waitingTask); }
      for (let item of newTasks) {
        simulationReducer[item] = {};
        let msg = ""
        if (error && error.code === API_RES_MESSAGE) {
          msg = `==> ${error.msg}`;
          yield put(getVerificationLog(item));
          simulationReducer[item].simulationMsg = msg;
        } else {
          msg = `==> ${error}`;
          simulationReducer[item].endMsg = msg;
        }
      }

      yield delay(1000);
      yield put(updateCurrentSimulationInfo({ currentVerificationId, item: "startMsg", info: null }));
      yield put(updateCurrentSimulationInfo({ currentVerificationId, item: "progress", info: -1 }));
      yield put(changeVerificationList([]));
      const promise = yield call(checkVerificationStatus, currentVerificationId);
      let resultExist = false;

      if (promise && promise.status) {
        if (promise.status === VERIFY_SUCCESS) {
          resultExist = true;
        }
      };
      yield put(updateCurrentSimulationInfo({ currentVerificationId, item: "resultExist", info: resultExist }));

      return;
    }
  }

  let newReducer = yield select();
  let _simulationReducer = newReducer.RockyReducer.simulationReducer;
  if (_simulationReducer[currentVerificationId]) {
    _simulationReducer[currentVerificationId].cancelDisabled = false;
  }
  yield put(updateSimulationReducer(_simulationReducer));
  const verificationStatus = yield call(getVerificationWorkFlow, currentVerificationId);

  if (experimentTask) {
    yield cancel(experimentTask);
  }
  experimentTask = yield fork(runningExperimentLog, { experimentQueue: newTasks, groupId })

  if (verificationStatus && verificationStatus.length > 0) {
    if (workflowTask) {
      yield cancel(workflowTask);
    };

    const _workflowTask = yield fork(verificationWorkFlow, { verificationId: currentVerificationId, verificationWork: verificationStatus });
    updateWorkflowTask(_workflowTask);
    return;
  };
}

export function* getSweepStatus(action) {
  const { experimentQueue, groupId } = action;
  if (experimentTask) {
    yield cancel(experimentTask);
  }
  experimentTask = yield fork(runningExperimentLog, { experimentQueue, groupId })
}

function* runningExperimentLog(action) {
  const { experimentQueue, groupId } = action;
  let queue = [...experimentQueue];
  while (queue.length) {
    try {
      const { RockyReducer: { sweep: { experimentInfo: { id, experiments, base } }, project: { viewList } } } = yield select();
      if (id !== groupId || !viewList.length || !viewList.includes(EXPERIMENTS)) {
        yield cancel(experimentTask);
        queue = []
        return
      }

      const res = yield call(getExperimentListPromise, { experimentGroupId: groupId });
      if (res && res.experiments.length) {
        const runList = res.experiments.filter(item => [WAITING, VERIFY_RUNNING].includes(item.status))
        if (runList.length) {
          queue = runList.map(item => item.verificationId)
        } else {
          queue = []
        }
        let newExperiments = JSON.parse(JSON.stringify(experiments));
        newExperiments.forEach(item => {
          const exp = res.experiments.find(exp => exp.id === item.id);
          if (exp && !(item.status === ERROR && ![WAITING, VERIFY_RUNNING].includes(exp.status))) {
            item.status = exp.status;
          }
        })
        let newBase = JSON.parse(JSON.stringify(base));
        if (newBase) {
          const exp = res.experiments.find(exp => exp.id === newBase.id);
          if (exp) {
            newBase.status = exp.status;
          }
        }
        yield put(updateExperimentInfo(newExperiments, 'experiments'));
        yield put(updateExperimentInfo(newBase, 'base'));
      } else {
        queue = []
      }
    } catch (error) {
      console.error(error)
    }
    yield delay(5000)
  }
}

function* rockyExperimentsSaga() {
  yield takeEvery(START_ROCKY_EXPERIMENT, startExperiment);
}
export default rockyExperimentsSaga;